<mat-drawer-container>
  <mat-drawer #drawer position="end">
    <tgrid-modify-map-layer [layer]="selectedLayer"
                            [groups]="layerGroups()"
                            (cancelUpdate)="drawer.close()"
                            (layerUpdated)="handleLayerUpdate($event)">
    </tgrid-modify-map-layer>
  </mat-drawer>
  <mat-drawer-content>
    <h1>Layer Management</h1>

    <mat-accordion multi>
      @for (layerGroup of layerGroups(); track layerGroup.id) {
        <mat-expansion-panel hideToggle expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span>{{ layerGroup.displayName }}</span>
            </mat-panel-title>
            <mat-panel-description>
              @if (!layerGroup.editing) {
                <button mat-icon-button matTooltip="Edit" matTooltipPosition="above"
                        (click)="$event.stopPropagation(); enableGroupEditing(layerGroup)">
                  <mat-icon>edit</mat-icon>
                </button>
              } @else {
                <button mat-icon-button matTooltip="Cancel" matTooltipPosition="above"
                        (click)="$event.stopPropagation(); cancelGroupChanges(layerGroup)">
                  <mat-icon>cancel</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Save" matTooltipPosition="above"
                        (click)="$event.stopPropagation(); saveGroupChanges(layerGroup)">
                  <mat-icon>check</mat-icon>
                </button>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>

          @if (layerGroup.editing) {

              <form [formGroup]="editFormGroup" class="edit-layer-group">
                <mat-form-field appearance="outline" >
                  <mat-label>Group Name</mat-label>
                  <input matInput placeholder="Group Name" formControlName="{{layerGroup.uiHandle}}-name">
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Order</mat-label>
                  <input matInput type="number" placeholder="Order" formControlName="{{layerGroup.uiHandle}}-order">
                  <mat-hint>Values need to be in multiples of 100 for best results.</mat-hint>
                </mat-form-field>
              </form>

          }



          @for (layer of layerGroup.layers; track layer.id) {
            <div class="layer">
              <span>{{ layer.displayName }}</span>
              <button mat-icon-button matTooltip="Edit" matTooltipPosition="above"
                      (click)="setSelectedLayer(layer)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          }

        </mat-expansion-panel>

      }

    </mat-accordion>

  </mat-drawer-content>
</mat-drawer-container>






